'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TiSocialSkypeOutline = function TiSocialSkypeOutline(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm14.8 8.3c1.2 0 2.4 0.4 3.4 1 0.6-0.1 1.2-0.2 2-0.2 3 0 5.6 1.2 7.8 3.4 2.2 2.2 3.3 4.9 3.3 8.1 0 0.8-0.1 1.6-0.3 2.4 0.4 1 0.7 2 0.7 3 0 1.9-0.7 3.4-1.9 4.7-1.3 1.3-2.8 2-4.6 2-1 0-2-0.3-3-0.8-0.9 0.1-1.6 0.2-2 0.2-3.1 0-5.8-1.1-7.9-3.4s-3.3-4.9-3.3-8.1c0-0.7 0.1-1.5 0.2-2.3-0.6-1-0.9-2.1-0.9-3.4 0-1.8 0.7-3.4 1.9-4.6 1.3-1.3 2.8-2 4.6-2z m5.2 17.6c-0.7 0-1.2-0.1-1.6-0.3-0.5-0.3-0.8-0.5-0.9-0.7-0.4-0.8-0.7-1.2-0.7-1.2-0.1-0.4-0.3-0.7-0.6-1-0.3-0.2-0.7-0.4-1-0.4-0.5 0-0.9 0.2-1.2 0.5-0.3 0.3-0.4 0.6-0.4 1.1 0 0.6 0.2 1.3 0.7 2 0.4 0.7 1 1.3 1.8 1.7 1.1 0.6 2.4 0.9 4 0.9 1.3 0 2.5-0.2 3.5-0.6 1-0.5 1.8-1.1 2.2-1.8 0.5-0.8 0.8-1.6 0.8-2.5 0-0.8-0.1-1.5-0.4-2.1-0.3-0.5-0.7-0.9-1.3-1.3-0.6-0.4-1.2-0.7-1.9-1-1.2-0.3-2-0.5-2.4-0.6-0.3-0.1-0.6-0.1-0.9-0.2-0.4-0.1-0.6-0.1-0.7-0.2-0.4-0.1-0.7-0.2-0.9-0.3-0.2-0.2-0.5-0.3-0.6-0.6-0.2-0.2-0.3-0.4-0.3-0.6 0-0.5 0.2-0.8 0.7-1.1 0.5-0.3 1.1-0.5 1.9-0.5 0.9 0 1.5 0.1 1.9 0.4 0.5 0.4 0.8 0.8 1 1.3 0.3 0.4 0.5 0.8 0.6 0.9 0.3 0.2 0.6 0.3 1 0.3 0.4 0 0.8-0.1 1.2-0.5 0.3-0.3 0.4-0.7 0.4-1.1 0-0.3-0.1-0.8-0.3-1.3-0.3-0.4-0.7-0.8-1.1-1.2-0.5-0.4-1.1-0.7-1.9-1-0.8-0.2-1.6-0.4-2.6-0.4-1.2 0-2.3 0.2-3.2 0.6-0.9 0.3-1.7 0.8-2.2 1.5-0.5 0.7-0.7 1.5-0.7 2.4 0 0.8 0.2 1.6 0.7 2.2 0.5 0.7 1.2 1.2 1.9 1.5 0.8 0.3 1.8 0.6 2.9 0.9 0.2 0 0.5 0.1 0.8 0.1 0.3 0.1 0.5 0.2 0.7 0.3 0.3 0 0.4 0 0.6 0.1 0.4 0.1 0.8 0.4 1.1 0.7 0.3 0.2 0.5 0.6 0.5 1.1 0 0.5-0.3 1-0.8 1.4-0.6 0.4-1.4 0.6-2.3 0.6z m-5.2-20.9c-2.7 0-5.1 1-7 2.9-1.8 1.9-2.8 4.4-2.8 7 0 1.4 0.3 2.7 0.8 3.9-0.1 0.6-0.1 1.2-0.1 1.8 0 4.1 1.4 7.6 4.2 10.5 2.8 2.8 6.3 4.3 10.3 4.3 0.4 0 0.9 0 1.4-0.1 1.2 0.5 2.4 0.7 3.6 0.7 2.7 0 5.1-1 7-2.9 1.8-2 2.8-4.4 2.8-7.1 0-1.1-0.2-2.2-0.6-3.3 0.1-0.7 0.2-1.4 0.2-2.1 0-4.1-1.4-7.6-4.2-10.4-2.8-2.9-6.3-4.4-10.2-4.4-0.5 0-1 0-1.4 0.1-1.2-0.6-2.6-0.9-4-0.9z' })
        )
    );
};

exports.default = TiSocialSkypeOutline;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/ti/social-skype-outline.js
// module id = 3728
// module chunks = 0